/** @typedef {String} PathifiedSvgContent */
/** @typedef {String} FeatherIconsPathDefinition */
/** @typedef {{ prefix: 'fe', iconName: 'feVideo', icon: [Number|String, Number|String, import('feather-icons').FeatherAttributes, PathifiedSvgContent, FeatherIconsPathDefinition] }} FeatherVideoIconData */

/** @type {FeatherVideoIconData} */
const feVideo = {
  prefix: 'fe',
  iconName: 'video',
  icon: [
    24,
    24,
    '<polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-video"><path d="M23 7 L16 12 L23 17 L23 7 Z"/><path d="M3 5 H14 A2 2 0 0 1 16 7 V17 A2 2 0 0 1 14 19 H3 A2 2 0 0 1 1 17 V7 A2 2 0 0 1 3 5 z"/></svg>',
    'M23 7 L16 12 L23 17 L23 7 Z M3 5 H14 A2 2 0 0 1 16 7 V17 A2 2 0 0 1 14 19 H3 A2 2 0 0 1 1 17 V7 A2 2 0 0 1 3 5 z',
    '"xmlns"="http=//www.w3.org/2000/svg" "width"="24" "height"="24" "fill"="none" "stroke"="currentColor" "stroke-width"=2 "stroke-linecap"="round" "stroke-linejoin"="round"',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: 24,
      height: 24,
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 2,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
    },
  ],
}

export default feVideo
